import { Stack } from '@mui/material';
import { FC } from 'react';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
import { LiquidGlassRowCard } from '../../common/LiquidGlassRowCard';
export type AchievementCategoriesSkeletonProps = {
    count?: number;
};

export const AchievementCategoriesSkeleton: FC<AchievementCategoriesSkeletonProps> = ({ count = 5 }) => {
    return (
        <Stack gap={1.5}>
            {Array.from({ length: count }).map((_, i) => (
                <LiquidGlassRowCard key={i} borderRadius={16}>
                    <Stack direction="row" alignItems="center" gap={1.5} sx={{ p: 1.5 }}>
                        <ThemedSkeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: 1.5, flexShrink: 0 }} />
                        <Stack spacing={0.75} sx={{ flex: 1 }}>
                            <ThemedSkeleton variant="text" width="45%" height={18} />
                            <ThemedSkeleton variant="text" width="75%" height={14} />
                        </Stack>
                        <ThemedSkeleton variant="circular" width={24} height={24} />
                    </Stack>
                </LiquidGlassRowCard>
            ))}
        </Stack>
    );
};
